import {
  ADD_ZONE_FORM,
  CLEAR_ZONE_FORM,
  FORM_CLEAR,
  FORM_UPDATE
} from "./actionTypes";

const initialState = {
  form: {},
  zoneForm: {},
};

const formReducer = (localState = initialState, action) => {
  switch (action.type) {
    case FORM_UPDATE:
      const { data } = action.payload
      return {
        ...localState,
        form: data,
      };
    case FORM_CLEAR:
      return {
        ...localState,
        form: {}
      };
    case ADD_ZONE_FORM:
      const { zone } = action.payload
      return {
        ...localState,
        zoneForm: zone,
      };
    case CLEAR_ZONE_FORM:
      return {
        ...localState,
        zoneForm: {}
      };
    default:
      return localState;
  }
};
export default formReducer;
